var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#d9d9d9",
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    stroke: "#d9d9d9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.448,392.285H393.66V350.5c0-3.055-2.476-5.531-5.531-5.531h-5.381V169.59l2.417-1.06 c10.185-4.468,14.82-16.346,10.352-26.532c-2.485-5.664-7.265-9.605-12.769-11.225V91.067 c20.236-6.022,35.039-24.788,35.039-46.953c0-6.162-4.997-11.159-11.159-11.159h-75.658c-6.162,0-11.159,4.997-11.159,11.159 c0,22.166,14.803,40.93,35.039,46.953v46.779l-53.6,23.512l-31.639-40.583c-9.461-12.136-23.712-19.097-39.101-19.097 c-10.763,0-89.073,0-102.191,0c-26.147,0-47.526,21.271-47.658,47.418L79.92,297.046c-0.056,11.123,8.916,20.184,20.037,20.24 c0.035,0,0.069,0,0.104,0c11.075,0,20.081-8.95,20.137-20.037l0.743-147.951c0-0.001,0-0.001,0-0.002 c0.086-2.296,1.995-4.101,4.293-4.057c2.297,0.044,4.135,1.92,4.135,4.218c-0.01,203.8-0.437,16.734-0.437,338.378 c0,13.347,10.819,24.166,24.166,24.166s24.166-10.819,24.166-24.166V294.67h10.434v193.163c0,13.347,10.819,24.166,24.166,24.166 s24.166-10.819,24.166-24.166l0.009-344.047c1.506,1.12,23.342,29.357,43.077,54.687c5.675,7.279,15.554,9.755,23.972,6.06 l51.763-22.706v163.142h-5.382c-3.055,0-5.531,2.476-5.531,5.531v41.785h-30.787c-4.421,0-7.964,3.787-7.611,8.245 C309.147,446.167,340.826,512,368.798,512s59.651-65.833,63.259-111.47C432.411,396.078,428.896,392.285,424.448,392.285z M344.577,55.271h48.446c-4.232,9.149-13.498,15.511-24.223,15.511C358.076,70.783,348.81,64.421,344.577,55.271z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 182.209,
    cy: 41.733,
    r: 41.733
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/users2.90c8e3131c49a8c4566eca206123f577.svg";
export { ForwardRef as ReactComponent };